import { mapGetters } from 'vuex';

import commentForm from '@/components/helpers/commentForm/index.vue';

import Api from '@/utils/api';

import { DEFAULT_IMAGE } from '@/utils/const';

export default {
  components: {
    commentForm,
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,
      comment: '',
      loading: false,
      refreshKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  methods: {

    /**
         * Method for send and save comments
         */
    sendReportComment () {
      if (this.comment.trim() === '') {
        return;
      }

      this.loading = true;

      const params = {
        Author: this.user.UserId,
        InnerText: this.comment,
        ReportID: this.$route.params.id,
      };

      Api.reports
        .sendComment(params)
        .then((response) => {
          if (response.data.Status) {
            this.comment = '';

            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'info',
              show: true,
            });

            this.$emit('refresh');
            this.refreshKey++;
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }

          this.loading = false;
        });
    },

    /**
         * Method for change comment
         *
         * @param {String} newComment
         */
    changeCommentInput (newComment) {
      this.comment = newComment;
    },
  },
};
